var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');

var cloudInviteModal = {};

function normalizeErrors(error) {
  if (error && error.error) return [error.error];
  if (typeof error === 'string') return [error];
  return ['Unable to invite this user.'];
}

cloudInviteModal.editDialogue = function (options) {
  cloudInviteModal.email = prop('');
  cloudInviteModal.role = prop('instance-viewer');
  cloudInviteModal.homeTenantId = prop('');
  cloudInviteModal.errors = [];

  function submit() {
    cloudInviteModal.errors = [];
    return loaders.requestWithLoader({
      url: '/api/v1/user',
      method: 'POST',
      body: {
        email: cloudInviteModal.email(),
        role: cloudInviteModal.role(),
        homeTenantId: cloudInviteModal.homeTenantId()
      }
    })
    .then(function () {
      key.unbind('enter');
      if (options && options.submitCallback) options.submitCallback();
      modal.vm.close();
      m.redraw();
    })
    .catch(function (error) {
      cloudInviteModal.errors = normalizeErrors(error);
      m.redraw();
    });
  }

  cloudInviteModal.submit = submit;
  key.setScope('modal');
  key('enter', 'modal', submit);
  modal.vm.title('Invite User');
  modal.vm.body = cloudInviteModal.view;
  modal.vm.buttons([{ label: 'Send invitation', class: 'btn-good', func: submit }]);
  modal.vm.open();
};

cloudInviteModal.view = function () {
  return m('form', { role: 'form' }, [
    cloudInviteModal.errors.length ? m('div.red.mb2', cloudInviteModal.errors.map(function (error) { return m('div', error); })) : '',
    m('p', 'Nimrod Cloud will invite this person through Microsoft Entra. No local password or independent user is created.'),
    m('label', 'Email:'),
    m('input.form-control.mb2', {
      type: 'email',
      required: true,
      autocomplete: 'email',
      oninput: function (event) { cloudInviteModal.email(event.target.value); },
      value: cloudInviteModal.email()
    }),
    m('label', 'Instance role:'),
    m('select.form-control.mb2', {
      onchange: function (event) { cloudInviteModal.role(event.target.value); },
      value: cloudInviteModal.role()
    }, [
      m('option', { value: 'instance-viewer' }, 'Standard user'),
      m('option', { value: 'instance-admin' }, 'Instance administrator')
    ]),
    m('label', 'Microsoft account type:'),
    m('select.form-control.mb2', {
      onchange: function (event) { cloudInviteModal.homeTenantId(event.target.value); },
      value: cloudInviteModal.homeTenantId()
    }, [
      m('option', { value: '' }, 'Work or school Microsoft account'),
      m('option', { value: 'personal-microsoft-account' }, 'Personal Microsoft account (Outlook, Hotmail, or Live)')
    ]),
    m('p.f6.gray', 'Work or school accounts use your organization’s approved Microsoft tenant. Choose Personal Microsoft account for Outlook, Hotmail, or Live.')
  ]);
};

module.exports = cloudInviteModal;
